import { GET_ROSS1000_STRUTTURE } from 'iovisit-reggioemiliawelcome/actions';

const initialState = {
  loading: false,
  loaded: false,
  result: {},
  error: null,
  // updateLoaded: false,
  // updateError: null,
};

export default function ross1000strutture(state = initialState, action = {}) {
  switch (action.type) {
    case `${GET_ROSS1000_STRUTTURE}_PENDING`:
      return {
        ...state,
        loading: true,
        loaded: false,
        error: null,
      };
    case `${GET_ROSS1000_STRUTTURE}_SUCCESS`:
      return {
        ...state,
        loading: false,
        loaded: true,
        result: action.result,
        error: null,
      };
    case `${GET_ROSS1000_STRUTTURE}_FAIL`:
      return {
        ...state,
        loading: false,
        loaded: false,
        error: action.error,
      };

    // case RESET_STATE:
    //   return initialState;
    default:
      return state;
  }
}
